import { UploadActions } from "./UploadActions";
import { UploadListItem } from "./UploadContent";
import { UploadDropzone } from "./UploadDropzone";
import { UploadPreview } from "./UploadPreview";
import { UploadProgress } from "./UploadProgress";
import { UploadFormItem, UploadItem } from "./upload-item";
import { UploadRoot } from "./upload-root";

// Composable Upload component following Shadcn pattern
export const Upload = {
  Root: UploadRoot,
  FormItem: UploadFormItem,
  Item: UploadItem,
  Content: UploadListItem,
  Progress: UploadProgress,
  Actions: UploadActions,
  Preview: UploadPreview,
  Dropzone: UploadDropzone,
};

// Export types
export type * from "./types";
export { UploadActions } from "./UploadActions";
export { UploadListItem as UploadContent } from "./UploadContent";
export type { UploadDropzoneProps } from "./UploadDropzone";
export { UploadDropzone } from "./UploadDropzone";
export { UploadPreview } from "./UploadPreview";
export { UploadProgress } from "./UploadProgress";
export type { UploadFormItemProps } from "./upload-item";
export { UploadFormItem, UploadItem } from "./upload-item";
// Individual exports for flexibility
export { UploadRoot } from "./upload-root";

// Legacy export for backward compatibility (can be removed after migration)
export const DriverDocumentsFactory = {
  Root: UploadRoot,
  Item: UploadItem,
  Preview: UploadPreview,
};
